import { render, staticRenderFns } from "./EmailBroadcastStepOverview.vue?vue&type=template&id=52c76e33&scoped=true"
import script from "./EmailBroadcastStepOverview.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastStepOverview.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastStepOverview.vue?vue&type=style&index=0&id=52c76e33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c76e33",
  null
  
)

export default component.exports